import React from 'react';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'daily_cancellation_policies',
  namespace: 'cancellationPolicy',
  mountedUrl: '/daily-rental/cancellation-policies',
  title: 'Cancellation policies',
  columns: [
    { attribute: 'name' },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/cancellation-policy/containers/Listing.jsx